export type MatchingListState = 'loaded' | 'error' | 'unprofiled';

export type MatchingListErrorState = Exclude<MatchingListState, 'loaded'>;

const UNPROFILED_ERROR_GROUP = 'MATCHING_UPROFILED';
const UNPROFILED_ERROR_CODE_PREFIX = 'MATCHING_INSUFFICIENTLY_PROFILED';

interface MatchingBackendError {
  code?: string;
  group?: string;
}

export function getMatchingListErrorState(err: unknown): MatchingListErrorState {
  const errors: unknown = (err as { error?: { errors?: unknown } } | null)?.error?.errors;

  if (!Array.isArray(errors)) return 'error';

  const isUnprofiled = errors.some((item: MatchingBackendError | null) => {
    if (!item) return false;
    return (
      item.group === UNPROFILED_ERROR_GROUP ||
      (typeof item.code === 'string' && item.code.startsWith(UNPROFILED_ERROR_CODE_PREFIX))
    );
  });

  return isUnprofiled ? 'unprofiled' : 'error';
}
